import { SideNav, SideNavItems } from '@metrika/ui-kit/carbon';
import { styled } from '@metrika/ui-kit/emotion';

export const Dots = styled.span`
   background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' enable-background='new 0 0 16 16' viewBox='0 0 16 16'%3E%3Crect width='16' height='16' fill='none'/%3E%3Crect width='1' height='1' fill='%23fff'/%3E%3C/svg%3E");
   background-size: 16px;
   height: 100%;
   opacity: 0.25;
   filter: ${({ theme }) => (theme.name === 'white' ? 'invert(1)' : 'none')};
   position: fixed;
   width: 100%;
   top: 0;
   left: 0;
   bottom: 0;
   right: 0;
   pointer-events: none;
`;

export const SidebarMenuContainer = styled(SideNavItems)`
   //  background-color: ${({ theme }) => (theme.name === 'dark' ? theme.colors.uiBackground : theme.colors.ui01)};
   display: flex;
   flex-direction: column;
   width: 16rem;
   border-right: 1px solid ${({ theme }) => theme.colors.ui03};
`;

export const MetrikaSideNav = styled(SideNav, { shouldForwardProp: (n) => n !== 'onlyWorkspaces' })<{
   expanded: boolean;
   onlyWorkspaces?: boolean;
}>`
   display: flex;
   flex-direction: row;

   width: unset;
   max-width: 16rem;

   //hide < lg
   @media (max-width: 65.98rem) {
      width: ${({ expanded, onlyWorkspaces }) => (expanded ? (onlyWorkspaces ? 0 : '16rem') : 0)};
      //hide fixed buttons
      button {
         visibility: ${({ expanded }) => (expanded ? 'unset' : 'hidden')};
      }
   }
`;
